/**
 * Página de invitar. Misma estructura que la página de palabras guardadas
 * (cabecera del dashboard + barra inferior). Contenido pendiente de definir.
 */

import { useTranslation } from 'react-i18next';
import styles from './RewardsInvitePages.module.scss';

export function InvitePage() {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <header className={styles.page__header}>
        <h1 className={styles.page__title}>{t('invitePage.title')}</h1>
        <p className={styles.page__subtitle}>{t('invitePage.subtitle')}</p>
      </header>

      <div className={styles.page__placeholder}>
        <p>{t('invitePage.placeholder')}</p>
      </div>
    </div>
  );
}

InvitePage.displayName = 'InvitePage';
export default InvitePage;
